import { render } from "./ContractDetailView.vue?vue&type=template&id=4f2cfbb2"
import script from "./ContractDetailView.vue?vue&type=script&lang=js"
export * from "./ContractDetailView.vue?vue&type=script&lang=js"

import "./ContractDetailView.vue?vue&type=style&index=0&id=4f2cfbb2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__